'use client';

import { InverseHeader } from '@jouzen/ecom-components/layout';

import ProductBreakthrough from '@/app/components/LegacyLandingPage/components/ProductBreakthrough';

import FitnessFeatures from './_components/FitnessFeatures';
import FitnessHero from './_components/FitnessHero';
import FitnessPress from './_components/FitnessPress';
import FitnessPressAccolades from './_components/FitnessPressAccolades';
import FitnessTestimonials from './_components/FitnessTestimonials';

const Content = () => {
  return (
    <>
      <InverseHeader enter>
        <FitnessHero />
        <ProductBreakthrough />
      </InverseHeader>
      <FitnessFeatures />
      <FitnessPress />
      <FitnessTestimonials />
      <FitnessPressAccolades />
    </>
  );
};

export default Content;
